import React from 'react';
import { Collapse } from 'react-bootstrap';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeKey } from '../hooks/useConvertForTranslationKey';
const ClaimStateCategory = _ref => {
  let {
    category,
    index,
    markTaskComplete,
    specificStyle = undefined
  } = _ref;
  const [open, setOpen] = useState(false);
  const {
    t
  } = useTranslation();
  const labelClass = () => {
    if (specificStyle) {
      return '';
    } else {
      return category.status === 'completed' ? 'solid-border label-info' : 'solid-border';
    }
  };
  return /*#__PURE__*/React.createElement("td", {
    className: "text-center align-top"
  }, /*#__PURE__*/React.createElement("div", {
    onClick: () => setOpen(!open),
    "data-testid": "category-icon",
    style: specificStyle ? specificStyle : {},
    className: `label-round-xl cursor-pointer ${labelClass()}`
  }, /*#__PURE__*/React.createElement("span", {
    className: `${category.status === 'completed' && !specificStyle ? 'fa-inverse' : 'text-info'}`
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons"
  }, "description"))), /*#__PURE__*/React.createElement("h4", {
    className: "pt-4",
    style: {
      color: '#0078B9',
      fontSize: '1.2em'
    }
  }, t(makeKey(category.category_title))), /*#__PURE__*/React.createElement("span", {
    className: "cursor-pointer",
    onClick: () => setOpen(!open),
    "aria-controls": "tasks",
    "aria-expanded": open
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "arrow_downward")), /*#__PURE__*/React.createElement(Collapse, {
    in: open
  }, /*#__PURE__*/React.createElement("div", {
    id: "tasks"
  }, category.tasks.map((task, taskIndex) => /*#__PURE__*/React.createElement("p", {
    className: "cursor-pointer",
    key: taskIndex,
    onClick: () => markTaskComplete(category, index, taskIndex)
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons mx-1"
  }, task.completed ? 'done' : 'close'), t(makeKey(task.title)))))));
};
export default ClaimStateCategory;